<template>
  <div class="new-home-result">
    <strong>应用成果</strong>
    <p>
      来自各行各业的最佳实践，值得选择
      <span @click="$router.push('/result')">查看全部 > </span>
    </p>
    <div class="new-home-result-content">
      <div class="new-home-result-tag">
        <span
          v-for="(el, index) in resultTag"
          :key="index"
          :class="{ active: sceneTypeId == el.id }"
          @click="sceneType(el.id, index)"
          >{{ el.name }}</span
        >
      </div>
      <div class="new-home-result-info">
        <div class="new-home-result-info-img">
          <img
            :class="{ active: resultTagIndex == 0 }"
            src="@/assets/img/cg1.jpg"
            alt="图片"
          />
          <img
            :class="{ active: resultTagIndex == 1 }"
            src="@/assets/img/cg2.jpg"
            alt="图片"
          />
          <img
            :class="{ active: resultTagIndex == 2 }"
            src="@/assets/img/cg3.jpg"
            alt="图片"
          />
          <img
            :class="{ active: resultTagIndex == 3 }"
            src="@/assets/img/cg5.jpg"
            alt="图片"
          />
          <img
            :class="{ active: resultTagIndex == 4 }"
            src="@/assets/img/cg6.jpg"
            alt="图片"
          />
          <img
            :class="{ active: resultTagIndex == 5 }"
            src="@/assets/img/cg7.jpg"
            alt="图片"
          />
        </div>
        <div class="new-home-result-info-content">
          <strong>{{ achievementList.name }}场景介绍</strong>
          <p>{{ achievementList.contents }}</p>
          <div
            class="new-home-result-info-lable"
            v-if="achievementList.tagList != ''"
          >
            <span
              v-for="(item, index) in achievementList.tagList"
              :key="index"
              >{{ item.tag }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSceneList, getSceneInfo } from "@/api/achievement";
import VImg from "@/components/VImg";
export default {
  components: {
    VImg,
  },
  data() {
    return {
      resultTag: [],
      achievementList: "",
      resultTagIndex: 0,
      sceneTypeId: "",
    };
  },
  mounted() {
    this.loadgetSceneList();
  },
  methods: {
    sceneType(id, index) {
      this.sceneTypeId = id;
      this.resultTagIndex = index;
      this.loadgetSceneInfo();
    },
    loadgetSceneList() {
      let page = {
        current: 1,
        size: 6,
      };
      getSceneList(page).then((res) => {
        this.resultTag = res.records;
        this.sceneTypeId = res.records[0].id;
        this.loadgetSceneInfo();
      });
    },
    loadgetSceneInfo() {
      getSceneInfo(this.sceneTypeId).then((res) => {
        this.achievementList = res;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.new-home-result {
  padding: 64px 0 0;
  position: relative;
  > strong {
    display: block;
    font-size: 32px;
    line-height: 45px;
    color: #000;
    text-align: center;
    margin-bottom: 16px;
    position: relative;
    z-index: 3;
  }
  > p {
    font-size: 18px;
    line-height: 28px;
    color: #000;
    margin-bottom: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 3;
    > span {
      color: #ea0b06;
      margin-left: 12px;
      line-height: 24px;
      cursor: pointer;
    }
  }
  .new-home-result-content {
    position: relative;
    z-index: 3;
    .new-home-result-tag {
      width: 1280px;
      margin: 0 auto 20px;
      padding: 0 56px;
      display: flex;
      > span {
        height: 38px;
        border-bottom: 3px solid transparent;
        margin-right: 110px;
        font-size: 16px;
        line-height: 22px;
        color: #262626;
        transition: all 0.3s;
        cursor: pointer;
        white-space: nowrap;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          border-color: #d44c55;
        }
        &:hover {
          color: #d44c55;
        }
      }
    }
    .new-home-result-info {
      display: flex;
      .new-home-result-info-img {
        position: relative;
        width: 50%;
        height: 396px;
        > img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: ease 0.5s;
          &.active {
            opacity: 1;
          }
        }
      }
      .new-home-result-info-content {
        width: 50%;
        padding: 40px;
        background: #fff;
        > strong {
          display: block;
          font-size: 24px;
          font-weight: bold;
          line-height: 33px;
          color: #262626;
          margin-bottom: 24px;
        }
        > p {
          font-size: 14px;
          color: #666666;
          line-height: 20px;
          width: 600px;
          margin-bottom: 64px;
        }
        .new-home-result-info-lable {
          display: flex;
          margin-bottom: 40px;
          > span {
            height: 30px;
            background: rgba(234, 11, 6, 0.1);
            border-radius: 4px;
            line-height: 30px;
            padding: 0 14px;
            font-size: 16px;
            color: #ea0b06;
            margin-right: 12px;
          }
        }
      }
    }
  }
}
</style>
